module.exports = __webpack_public_path__ + "static/member2-a51a1a012b9e6823b4c7911312182dd7.png";